// Salon-Variante des Builders. Nur der OBERE Konfig-Kopf ist neu gestaltet
// (siehe salon-config-head.ts). Matrix, Terminliste, Share-Panel etc.
// bleiben unverändert — identisch zum klassischen Builder unter /basic.

import { Store } from '../store';
import { renderAppHeader } from './app-header';
import { renderSalonConfigHead } from './salon-config-head';
import { renderMatrix, setBusyEvents } from './matrix';
import { renderAppointmentList } from './appointment-list';
import { renderSharePanel } from './share-panel';
import { renderCalendarPanel } from './calendar-panel';
import { renderRangeExtenders } from './range-extenders';

export function renderSalonBuilderView(root: HTMLElement): void {
  const store = new Store();
  root.append(
    renderAppHeader(),
    renderSalonConfigHead(store),
    renderCalendarPanel({ onUpdate: setBusyEvents }),
    renderMatrix(store),
    renderRangeExtenders(store),
    renderAppointmentList(store),
    renderSharePanel(store),
  );
}
